module.exports = __webpack_public_path__ + "static/media/app-store-badge.78cb25d3.svg";